import { gql } from '@apollo/client';

export const TRACK_PAGE_EVENT = gql`
  mutation TrackPageEvent($input: TrackPageEventInput!) {
    trackPageEvent(input: $input) {
      success
      message
    }
  }
`;
